import { render } from "./slideshowComponent.vue?vue&type=template&id=178d298e"
import script from "./slideshowComponent.vue?vue&type=script&lang=js"
export * from "./slideshowComponent.vue?vue&type=script&lang=js"

import "./slideshowComponent.vue?vue&type=style&index=0&id=178d298e&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__